import { SELECTED_FEATURE_COLOR, TARGET_STROBE_OPACITY } from '@utils/map/map.constants';
import { SHOW_TARGET_STROBE_MAX_ZOOM } from '@utils/map/mapZoom.constants';
import { FillLayerSpecification, LineLayerSpecification } from 'mapbox-gl';

import { FeatureTypeEnum, LayerNameEnum, SourceNameEnum } from '@/types/map.types';

export const strobeSectorLayer: FillLayerSpecification = {
  id: LayerNameEnum.STROBE_SECTORS,
  type: 'fill',
  source: SourceNameEnum.STROBES,
  maxzoom: SHOW_TARGET_STROBE_MAX_ZOOM,
  filter: ['==', 'featureType', FeatureTypeEnum.STROBE_SECTOR],
  paint: {
    'fill-color': [
      'case',
      ['boolean', ['feature-state', 'isSelected'], false],
      SELECTED_FEATURE_COLOR,
      ['get', 'color'],
    ],
    'fill-outline-color': 'black',
    'fill-opacity': TARGET_STROBE_OPACITY,
  },
};

export const strobeAzimuthLayer: LineLayerSpecification = {
  id: LayerNameEnum.STROBE_AZIMUTHS,
  type: 'line',
  source: SourceNameEnum.STROBES,
  maxzoom: SHOW_TARGET_STROBE_MAX_ZOOM,
  filter: ['==', 'featureType', FeatureTypeEnum.STROBE_AZIMUTH],
  paint: {
    'line-color': 'black',
    'line-width': 0.1,
  },
};
